import { gql } from '@apollo/client';
import { MESSAGE_FIELDS_FRAGMENT } from './messageFieldsFragment.gql';

const MESSAGE_CREATE_SUBSCRIPTION = gql`
  ${MESSAGE_FIELDS_FRAGMENT}
  subscription onCreateMessage($input: MessageSubscriptionFilterInput) {
    onCreateMessage(input: $input) {
      ...MessageFields
    }
  }
`;

const MESSAGE_UPDATE_SUBSCRIPTION = gql`
  ${MESSAGE_FIELDS_FRAGMENT}
  subscription onUpdateMessage($input: MessageSubscriptionFilterInput) {
    onUpdateMessage(input: $input) {
      ...MessageFields
    }
  }
`;

const MESSAGE_ENTER_SUBSCRIPTION = gql`
  ${MESSAGE_FIELDS_FRAGMENT}
  subscription onEnterMessage($input: MessageSubscriptionFilterInput) {
    onEnterMessage(input: $input) {
      ...MessageFields
    }
  }
`;

const MESSAGE_LEAVE_SUBSCRIPTION = gql`
  ${MESSAGE_FIELDS_FRAGMENT}
  subscription onLeaveMessage($input: MessageSubscriptionFilterInput) {
    onLeaveMessage(input: $input) {
      ...MessageFields
    }
  }
`;

export {
  MESSAGE_CREATE_SUBSCRIPTION,
  MESSAGE_UPDATE_SUBSCRIPTION,
  MESSAGE_ENTER_SUBSCRIPTION,
  MESSAGE_LEAVE_SUBSCRIPTION,
};
